import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadTransactionComponent } from './upload-transaction.component';
import { RouterModule, Routes } from '@angular/router';
import { UploadDocumentModule } from '@app/transactions/components/upload-document/upload-document.module';

const routesInfo: Routes = [
    {
        path: '',
        component: UploadTransactionComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routesInfo)],
    exports: [RouterModule]
})
export class UploadTransactionRoutingModule {}

@NgModule({
    declarations: [UploadTransactionComponent],
    exports: [UploadTransactionComponent],
    imports: [CommonModule, UploadTransactionRoutingModule, UploadDocumentModule]
})
export class UploadTransactionModule {}
